export const filterTypes = Object.freeze({
  EMAIL: "email",
  DATE: "date"
});
